import { isObject } from 'lodash';

export class SnPoint {
  public static convert(pointLike: SnPointLike): SnPoint {
    if (pointLike instanceof SnPoint) {
      return pointLike;
    }

    if (Array.isArray(pointLike)) {
      return new SnPoint(...pointLike);
    }

    if (!Array.isArray(pointLike) && isObject(pointLike)) {
      return new SnPoint(pointLike.x, pointLike.y);
    }

    throw new Error(`
      SnPointLike argument must be specified as a SnPoint instance,
      an object {x: <x>, y: <y>} or an array of [<x>, <y>]
    `);
  }

  constructor(public x: number, public y: number) {}

  public clone(): SnPoint {
    return new SnPoint(this.x, this.y);
  }

  public round(): SnPoint {
    const point = this.clone();
    point.x = Math.round(this.x);
    point.y = Math.round(this.y);

    return point;
  }

  public subtract(pointLike: SnPointLike): SnPoint {
    const targetPoint = SnPoint.convert(pointLike);

    const point = this.clone();
    point.x -= targetPoint.x;
    point.y -= targetPoint.y;

    return point;
  }

  public toArray(): [number, number] {
    return [this.x, this.y];
  }

  public toString(): string {
    return `(${this.x}, ${this.y})`;
  }

  public toJSON(): ISnPointLiteral {
    return {
      x: this.x,
      y: this.y,
    };
  }
}

export interface ISnPointLiteral {
  x: number;
  y: number;
}

export type SnPointLike = SnPoint | ISnPointLiteral | [number, number];
